<template>
  <div>
    <div :class="titleSize == 'sm' ? 'small-indications-header' : 'indications-header'">
      <h3 :class="titleSize == 'sm' ? 'small-indications-title' : 'medium-indications-title'">{{title}}</h3>
      <div class="indications-btnbar">
        <div class="indications-btnbar-group">
          <b-dropdown 
            toggle-class="add-indication-btn text-decoration-none" 
            variant="outline-primary" 
            :size="titleSize == 'sm' ? 'sm' : 'md'"
            :style=" dropdownOpen ? 'z-index: 1021' : ''"
            @show="openDropdown"
            @hide="closeDropdown"
            no-caret
          >
            <template v-slot:button-content>
              <IconAdd
                :width="titleSize == 'sm' ? '20px' : '24px'"
                :height="titleSize == 'sm' ? '20px' : '24px'"
              /> Agregar
            </template>
            <b-dropdown-item
              href="#"
              v-for="(preset, index) in presets"
              :key="'preset-'+index"
              @click="addIndication(preset.text)"
            >
              {{preset.name}}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <IndicationsTable v-model="dataIndications"/>
  </div>
</template>

<script>
import IndicationsTable from "./table/IndicationsTable";
import IconAdd from "./icon/IconAdd";

export default {
  name: "ProgramIndications",
  components: { IconAdd, IndicationsTable },
  model: {
    prop: "indications",
    event: "change",
  },
  props: {
    indications: {
      type: Array,
      default: function () {return [];},
    },
    presets: {
      type: Array,
      default: function () {return []},
    },
    title: {
      type: String,
      default: "Indicaciones generales",
    },
    titleSize: {
      type: String,
      default: "md",
    }
  },
  data: function () {
    return {
      dataIndications: this.indications,
      dropdownOpen: false
    };
  },
  watch: {
    dataIndications: function (val) {
      this.$emit("change", val);
    },
  },
  methods: {
    addIndication: function (text) {
      this.dataIndications.push({
        text: text,
      });
    },
    openDropdown: function () {
      this.dropdownOpen = true
    },
    closeDropdown: function () {
      this.dropdownOpen = false
    }
  },
};
</script>

<style scoped lang="scss">

.indications-header {
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;
  background-color: white;
  padding: map_get($spacers, 1) 0;
}
.small-indications-header {
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;
  background-color: white;
  padding: 0;
}

.small-indications-title {
  margin: $spacer auto;
  font-size: $h5-font-size;
}

.medium-indications-title {
  margin: $spacer auto;
  font-size: $h4-font-size;
}

.indications-btnbar {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

</style>

<style lang="scss">
 .indications-btnbar .indications-btnbar-group button {
    margin: 0 map_get($spacers, 1);
    height: 2.5rem;
    padding: 0.25rem 0.5rem;
    line-height: 1;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    & svg {
      fill: currentColor;
      margin-bottom: 3px;
    }
  }
</style>